// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__CDjSf","text":"SelectPayment_text__2Jho-","title":"SelectPayment_title__3T0uQ","btn":"SelectPayment_btn__2jrDP"};